import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo } from 'react';
import styled from 'styled-components';

import AutoScroller from '../components/autoScroller';
import PersonCard from '../components/personCard';

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
`;

const GridItem = styled.div`
  flex: 0 0 ${100 / 3}%;
  max-width: ${100 / 3}%;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
`;

const StyledPersonCard = styled(PersonCard)`
  height: 100%;
`;

const PersonCardSelect = memo(({ className, onSelect, people, selectedPerson }) => {
  const items = useMemo(
    () =>
      people.map(person => ({
        isSelected: selectedPerson != null && selectedPerson.id === person.id,
        person,
      })),
    [people, selectedPerson],
  );

  const handleRemove = useCallback(() => onSelect({ person: undefined }), [onSelect]);

  if (items.length === 0) {
    return null;
  }

  return (
    <AutoScroller className={className}>
      <Grid>
        {items.map(({ isSelected, person }) => (
          <GridItem key={person.id}>
            <StyledPersonCard
              isSelected={isSelected}
              onRemove={handleRemove}
              onSelect={onSelect}
              person={person}
            />
          </GridItem>
        ))}
      </Grid>
    </AutoScroller>
  );
});

PersonCardSelect.defaultProps = {
  className: undefined,
  onSelect: () => {},
  people: [],
  selectedPerson: undefined,
};

PersonCardSelect.propTypes = {
  className: PropTypes.string,
  onSelect: PropTypes.func,
  people: PropTypes.arrayOf(PropTypes.object),
  selectedPerson: PropTypes.object,
};

export default PersonCardSelect;
